import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ObjectResponse } from '../interfaces';

import { CountryWithRegion, WtpCountry } from '../models';
import { BaseService } from './base/base.service';
import { AppConfig } from './app-config';

@Injectable()
export class WtprService extends BaseService<any> {

  constructor(protected http: HttpClient, protected config: AppConfig) {
    super(http, config);
  }
  // wtp/country/USA
  public getSingleCountryData(isoCode: string): Observable<ObjectResponse<CountryWithRegion>> {
    const apiUrl = `${this.getResourceUrl()}country/${isoCode}`;
    return this.http.get<ObjectResponse<CountryWithRegion>>(apiUrl);
  }

  // wtp/all-world/1
  public getWorldCountryData(id: string): Observable<ObjectResponse<WtpCountry[]>> {
    const apiUrl = `${this.getResourceUrl()}all-world/${id}`;
    return this.http.get<ObjectResponse<WtpCountry[]>>(apiUrl);
  }

  public getMneData(): Observable<ObjectResponse<WtpCountry[]>> {
    const apiUrl = `${this.getResourceUrl()}mne-world/`;
    return this.http.get<ObjectResponse<WtpCountry[]>>(apiUrl);
  }

  protected getResourceUrl(): string {
    return `${this.baseUrl}wtp/`;
  }

}
